module.exports = __webpack_public_path__ + "media/application/images/svgs/sidebar-e34137eeec41b7efd08ff530759ff000.svg";